import React, { useState, useEffect, useMemo } from 'react';

import { Slider, Select, Input } from 'antd';
import { useGlobalContext } from '../../context/provider'

const SelectZone = ({ selectdata, setFilterSituation, cate }) => {
    const { screen } = useGlobalContext()
    const [firstlenght, setFirstlenght] = useState(0)
    const [lastlenght, setLastlenght] = useState(0)
    const [form, setForm] = useState('')
    const [partner, setPartner] = useState('')
    const [status, setStatus] = useState('')
    const [sort, setSort] = useState('')
    const [book_type, setBook_type] = useState([])

    const [getType, setGetType] = useState('')
    const [book_cate, setBookCate] = useState([])
    const [getCate, setGetCate] = useState('')
    const [search, setSearch] = useState('')

    const onChangeLength = (value) => {
        setFirstlenght(value[0])
        setLastlenght(value[1])
    };

    const cateOptions = useMemo(() => {
        const base = [{ label: 'ทั้งหมด', value: '' }];

        if (!Array.isArray(cate)) return base;
        if (!getType) return base;

        const type = cate.find(t => String(t.type_id) === String(getType));
        const items =
            type?.category?.map((c) => ({ label: c.name, value: c.id })) ?? [];

        return [...base, ...items];
    }, [cate, getType]);




    const RemoveAll = () => {
        setFirstlenght(0)
        setLastlenght(0)
        setForm('')
        setPartner('')
        setStatus('')
        setSort('')
        setGetCate('')
        setGetType('')
        setSearch('')
    }

    const SetAll = () => {
        if (screen === 'desktop') {
            setFilterSituation(prev => ({
                ...prev,
                search: search,
                lengthPrice: firstlenght > 0 || lastlenght > 0 ? [firstlenght, lastlenght] : null,
                form: form === '' ? null : form,
                partner: partner === '' ? null : partner,
                status: status === '' ? null : status,
                sort: sort === '' ? null : sort,
                // book_type:getType ===''? null : getType,
                // book_cate:getCate ===''? null : getCate
            }))
        } else {
            setFilterSituation(prev => ({
                ...prev,
                search: search,
                lengthPrice: firstlenght > 0 || lastlenght > 0 ? [firstlenght, lastlenght] : null,
                form: form === '' ? null : form,
                partner: partner === '' ? null : partner,
                status: status === '' ? null : status,
                sort: sort === '' ? null : sort,
                book_type: getType === '' ? null : getType,
                book_cate: getCate === '' ? null : getCate
            }))
        }
        setFilterSituation(prev => ({
            ...prev,
            search: search,
            lengthPrice: firstlenght > 0 || lastlenght > 0 ? [firstlenght, lastlenght] : null,
            form: form === '' ? null : form,
            partner: partner === '' ? null : partner,
            status: status === '' ? null : status,
            // sort:sort==='' ? null : sort,
            // book_type:getType ===''? null : getType,
            // book_cate:getCate ===''? null : getCate
        }))
    }

    useEffect(() => {
        const selected = cate?.find((data) => data.id === getType);
        const items = selected ? selected.items : [];
        setBookCate(items);
    }, [getType]);



    return (
        <>
            {screen !== 'desktop' &&
                <div className='col-span-12  ' >
                    <div className='flex flex-col'>
                        <label className='text-[16px]'>
                            <span>ประเภทอีบุ๊ก</span>
                        </label>
                        <Select value={getType} onChange={(value) => setGetType(value)} placeholder="เลือกประเภทอีบุ๊ก" options={[{ label: 'ทั้งหมด', value: '' }, ...cate.map(data => ({
                            value: data.type_id, label: data.type_name
                        }))]} />
                    </div>
                    <div className='flex flex-col mt-[10px]'>
                        <label className='text-[16px]'>
                            <span>หมวดหมู่</span>
                        </label>
                        <Select value={getCate} onChange={(value) => setGetCate(value)} placeholder="เลือกหมวดหมู่" options={cateOptions} />
                    </div>
                </div>
            }
            <div className='col-span-12 flex flex-col'>
                <div className="mb-2">ชื่ออีบุ๊ค</div>
                <Input value={search} onChange={(e) => setSearch(e.target.value)} className='h-[40px] ' prefix placeholder='ค้นหา' allowClear />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex flex-col'>
                <label className='flex justify-between text-[16px]'>
                    <span>ช่วงราคา</span>
                    <span>{firstlenght}-{lastlenght} ฿</span>
                </label>

                <Slider range step={50}
                    value={[firstlenght, lastlenght]}
                    min={0}
                    max={800}
                    onChange={onChangeLength}
                />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex flex-col'>
                <label className='text-[16px]'>
                    <span>รูปแบบ</span>
                </label>
                <Select value={form} onChange={(value) => setForm(value)} placeholder="ค้นหาจากรูปแบบ" options={[{ label: 'ทั้งหมด', value: '' }, { label: 'เล่ม', value: 'book' }, { label: 'แพ็ค', value: 'pack' }]} />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex flex-col'>
                <label className='text-[16px]'>
                    <span>ผู้จำหน่าย</span>
                </label>
                <Select value={partner} onChange={(value) => setPartner(value)} placeholder="ค้นหาจากผู้จำหน่าย" options={[{ label: 'ทั้งหมด', value: '' }, ...selectdata?.partner]} />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex flex-col'>
                <label className='text-[16px]'>
                    <span>สถานะหนังสือ</span>
                </label>
                <Select value={status} onChange={(value) => setStatus(value)} placeholder="ค้นหาจากสถานะหนังสือ" options={[{ label: 'ทั้งหมด', value: '' }, { label: 'ยังไม่จบ', value: 'ongoing' }, { label: 'จบแล้ว', value: 'completed' }]} />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex flex-col'>
                <label className='text-[16px]'>
                    <span>การจัดเรียง</span>
                </label>
                <Select value={sort} onChange={(value) => setSort(value)} placeholder="การจัดเรียง"
                    options={[
                        { label: 'เก่าสุด-ใหม่สุด', value: 'old-new' },
                        { label: 'ใหม่สุด-เก่าสุด', value: 'new-old' },
                        { label: 'ถูกสุด-แพงสุด', value: 'C-E' },
                        { label: 'แพงสุด-ถูกสุด', value: 'E-C' },
                        { label: 'ก-ฮ', value: 'a-z' },
                        { label: 'ฮ-ก', value: 'z-a' }
                    ]} />
            </div>
            <div className='col-span-12 md:col-span-6 xl:col-span-4 flex items-end justify-end gap-[1em]'>
                <button onClick={RemoveAll} className='w-[30px] h-[40px] text-danger' >ล้าง</button>
                <button onClick={SetAll} className='w-[93px] h-[40px] rounded-[4px] bg-[#47B081] text-white' >ยืนยัน</button>
            </div>
        </>
    )
}

export default SelectZone